import { AddOutlined } from '@mui/icons-material'
import { Button, Stack, Typography } from '@mui/material'
import type { InternalCalibrationArea } from '@ulysses-inc/harami_api_client'
import type { FC } from 'react'
import { CalibrationAreaTable } from './CalibrationAreaTable'

type Props = {
  onClickExistingCalibrationArea: (
    calibrationArea: InternalCalibrationArea,
  ) => void
  addNewCalibrationArea: () => void
  errorMessages: string[]
  calibrationAreas: InternalCalibrationArea[]
  canSave: boolean
  deleteCalibrationArea: (id: string) => void
}

export const CalibrationAreaPanel: FC<Props> = ({
  onClickExistingCalibrationArea,
  calibrationAreas,
  canSave,
  addNewCalibrationArea,
  errorMessages,
  deleteCalibrationArea,
}) => {
  return (
    <Stack spacing={2} py={2}>
      <Stack sx={{ px: 2, gap: 2 }}>
        <Button
          variant="contained"
          color="secondary"
          size="medium"
          startIcon={<AddOutlined />}
          disabled={!canSave}
          onClick={addNewCalibrationArea}
          sx={{ width: 'fit-content' }}
        >
          位置補正基準を追加
        </Button>
        {errorMessages.map(error => (
          <Typography fontSize={16} key={error} color="error" fontWeight="bold">
            {error}
          </Typography>
        ))}
      </Stack>
      <CalibrationAreaTable
        onClickCalibrationArea={onClickExistingCalibrationArea}
        calibrationAreas={calibrationAreas}
        deleteCalibrationArea={deleteCalibrationArea}
      />
    </Stack>
  )
}
